import React, { useEffect, useState } from "react";
import styles from "./SideNavBar.module.scss";
import Logo from "../../../Assests/Images/tfs_logo.png";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import { useSelector } from "react-redux";
import { FaUsers, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

export default function SideNavBar({ menuItems = [] }) {
  const userData = useSelector((state) => state.auth.user);
  const navigateTo = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [isExpanded, setIsExpanded] = useState(true);

  const handleOnClick = (item) => {
    navigateTo(item.path);
    setActivePath(item.path);
  };

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const mainContent = document.querySelector('.main-content');
    if (mainContent) {
      if (isExpanded) {
        mainContent.classList.add('sidebar-expanded');
        mainContent.classList.remove('sidebar-collapsed');
      } else {
        mainContent.classList.add('sidebar-collapsed');
        mainContent.classList.remove('sidebar-expanded');
      }
    }
  }, [isExpanded]);

  return (
    <div className={`${styles.sidebarWrapper} ${isExpanded ? styles.expanded : styles.collapsed}`}>
      <div className={styles.blurBackground}></div>
      <div className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <div className={styles.logoContainer}>
            <img src={Logo} alt="TFS Logo" className={styles.logo} />
          </div>
          <div 
            className={styles.toggleButton}
            onClick={toggleSidebar}
            aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
          >
            {isExpanded ? <FaChevronLeft /> : <FaChevronRight />}
          </div>
        </div>

        <ul className={styles.navList}>
          {menuItems.map((item, index) => (
            item["access_role_ids"].indexOf(_.get(userData,"role_id")) > -1 && (
              <li
                key={index}
                className={`${styles.navItem} ${
                  activePath === item.path ? styles.active : ""
                }`}
                onClick={() => handleOnClick(item)}
              >
                <div className={styles.navLink}>
                  <span className={styles.icon}>{item.icon}</span>
                  <span className={styles.label}>
                    {[3,4,5].indexOf(_.get(userData,"role_id")) > -1 && 
                     item.label === "Leads" ? "My Leads" : item.label}
                  </span>
                </div>
                {activePath === item.path && (
                  <div className={styles.activeIndicator}></div>
                )}
              </li>
            )
          ))}
        </ul>
      </div>
    </div>
  );
}
